import { reportRetentionsTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_RETENTIONS_FILTERS,
  RESTORE_INITIAL
} = reportRetentionsTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportRetentionsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_RETENTIONS_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
